module.exports = __webpack_public_path__ + "img/LogoCustosMobile_Gris.b717329d.png";